import React from 'react';

type Props = {
  className: string;
};

const PlayBorder: React.FC<Props & React.SVGProps<SVGSVGElement>> = ({
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      aria-hidden="true"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.5 3L20.5 12L6.5 21V3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlayBorder;
